import { combineReducers } from 'redux';
import matchmaking from './matchmaking';
import settings from './settings';
import connection from './connection';
import featuredStreams from './featuredStreams';
import subHype from './subHype';
import chat from './chat';
import popups from './popups';
import windowSize from './windowSize';
import disputes from './disputes';
import user from './user';
import page from './page';
import mod from './mod';
import windowFocus from './windowFocus';
import privateChat from './privateChat';
import matchSelection from './matchSelection';
import matchRoom from './matchRoom';
import notifications from './notifications';
import findMatch from './findMatch';
import doublesParty from './doublesParty';
import dockChat from './dockChat';

const rootReducer = combineReducers({
	matchmaking,
	settings,
	connection,
	featuredStreams,
	subHype,
	chat,
	popups,
	windowSize,
	disputes,
	user,
	page,
	mod,
	windowFocus,
	privateChat,
	matchSelection,
	matchRoom,
	notifications,
	findMatch,
	doublesParty,
	dockChat,
});

export default rootReducer;
